export default "__VITE_ASSET__9TBdqyum__"